import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import React from "react";
import shortid from "shortid";

/**
 * This HOC injects unique ids into the lower order component (LOC)
 *
 * 1. It makes sure to generate the unique ids ONCE during creation of the component
 * 2. It allows ids to be passed in as props, which take precedence
 * 3. If the prop provided id changes, the change is passed down to the LOC
 */
const uniqueID = function (propNames) {
  let {
    generate = shortid.generate
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const generateKeysReducer = (obj, key) => ({
    [key]: generate(),
    ...obj
  });
  return LowerOrderComponent => /*#__PURE__*/React.forwardRef((props, ref) => {
    const fallbackIds = React.useRef(_reduceInstanceProperty(propNames).call(propNames, generateKeysReducer, {}));
    return /*#__PURE__*/React.createElement(LowerOrderComponent, _extends({
      ref: ref
    }, fallbackIds.current, props));
  });
};
export default uniqueID;
export const useUniqueID = function (override) {
  let {
    generate = shortid.generate
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    current: isControlled
  } = React.useRef(typeof override !== 'undefined');
  const idRef = React.useRef();
  if (isControlled) {
    return override;
  }
  if (!idRef.current) {
    idRef.current = generate();
  }
  return idRef.current;
};